export enum ReportGenerationStatusTypeEnum {
  IN_PROGRESS = 'IN_PROGRESS',
  FINISHED = 'FINISHED',
  FAILED = 'FAILED',
  NO_DATA = 'NO_DATA',
}
